"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.46 4.72 6.599 9.493a.74.74 0 0 0 0 1.06.774.774 0 0 0 1.08 0l3.557-3.492v8.689c0 .414.342.75.764.75a.757.757 0 0 0 .764-.75V7.06l3.557 3.493a.774.774 0 0 0 1.08 0 .74.74 0 0 0 0-1.06l-4.86-4.773a.774.774 0 0 0-1.081 0Zm8.04 10.983v2.39h-15v-2.39c0-.388-.336-.703-.75-.703s-.75.315-.75.703v2.813c0 .046.005.091.014.135a.77.77 0 0 0-.014.146c0 .388.288.703.643.703h16.714c.355 0 .643-.315.643-.703a.769.769 0 0 0-.014-.146.664.664 0 0 0 .014-.135v-2.813c0-.388-.336-.703-.75-.703s-.75.315-.75.703Z",
    clipRule: "evenodd"
  })]
});